import { defineMessages } from 'react-intl';

const messages = defineMessages({
  review: { id: 'modules-expertDirectory-review' },
  reviews: { id: 'modules-expertDirectory-reviews' },
  reviewsInTotal: { id: 'modules-expertDirectory-reviewsInTotal' },
  singleItemListLink: { id: 'modules-expertDirectory-singleItemListLink' },
  customerChoice: { id: 'modules-expertDirectory-awards-customerChoice' },
  topServiceProvider: { id: 'modules-expertDirectory-awards-topServiceProvider' },
  topRecommendation: { id: 'modules-expertDirectory-awards-topRecommendation' },
  checkAlt: { id: 'modules-expertDirectory-checkAlt' },
  checkTooltip: { id: 'modules-expertDirectory-checkTooltip' },
  sources: { id: 'modules-expertDirectory-sources' },
  singleExternalSource: { id: 'modules-expertDirectory-singleExternalSource' },
  onlyExternalSources: { id: 'modules-expertDirectory-onlyExternalSources' },
  noReviews: { id: 'modules-expertDirectory-noReviews' },
  profileLocations: { id: 'modules-expertDirectory-profileLocations' },
  profileLocationsLink: { id: 'modules-expertDirectory-profileLocationsLink' },
  noStarsTooltip: { id: 'modules-expertDirectory-noStarsTooltip' },
  noStarsTooltipTitle: { id: 'modules-expertDirectory-noStarsTooltipTitle' },
  noStarsTooltipListItem: { id: 'modules-expertDirectory-noStarsTooltipListItem' },
  noStarsTooltipListItem1: { id: 'modules-expertDirectory-noStarsTooltipListItem1' },
  noStarsTooltipListItem2: { id: 'modules-expertDirectory-noStarsTooltipListItem2' },
  noStarsTooltipListItem3: { id: 'modules-expertDirectory-noStarsTooltipListItem3' },
  reviewsPublished: { id: 'modules-expertDirectory-reviewsPublished' },
  phoneLabel: { id: 'modules-expertDirectory-phoneLabel' },
  poor: { id: 'modules-expertDirectory-poor' },
  negative: { id: 'modules-expertDirectory-negative' },
  neutral: { id: 'modules-expertDirectory-neutral' },
  positive: { id: 'modules-expertDirectory-positive' },
  excellent: { id: 'modules-expertDirectory-excellent' },
  hoverExternalLink: { id: 'modules-expertDirectory-hoverExternalLink' },
  hoverIndustry: { id: 'modules-expertDirectory-hoverIndustry' },
  hoverTitle: { id: 'modules-expertDirectory-hoverTitle' },
  hoverWebsiteUrl: { id: 'modules-expertDirectory-hoverWebsiteUrl' },
  hoverRatings: { id: 'modules-expertDirectory-hoverRatings' },
  hoverTel: { id: 'modules-expertDirectory-hoverTel' },
  hoverEmail: { id: 'modules-expertDirectory-hoverEmail' },
  awardsTooltip: { id: 'modules-expertDirectory-awardsTooltip' },
  awardsTooltipLink: { id: 'modules-expertDirectory-awardsTooltipLink' },
});

export default messages;
